// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/font/roboto/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/font/roboto/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/font/roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/font/roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/font/roboto/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/font/roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* My css */
:root {
    --color1Achemed: #00468B;
    --color2Achemed: #3C8BBA;
    --color3Achemed: #F7D5CD;
    --color4Achemed: #56CAF0;
    --color5Achemed: #8CE4F9;
}

html,
body {
    height: 100%;
}

* {
    font-family: 'Roboto';
}

html {
    overflow: hidden;
}

.show {
    z-index: 10000;
}

.screenContainer {
    background: #f2f2f2;
    padding: 18px 30px;
    min-height: 100%;
}

.link-menu {
    margin-left: 10px;
}


@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 200;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    font-weight: 700;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    font-weight: 800;
    font-style: normal;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    font-weight: 900;
    font-style: normal;
}

.text-align-start {
    text-align: start;
}

.img-menu {
    margin-right: 10px;
    width: 20px;
}

.posConsult {
    color: #f2f2f2;
    /* ou qualquer outra propriedade que você queira ajustar */
}

.screenContainer {
    overflow: auto;
    max-height: calc(100vh - 56px);
    min-height: calc(100vh - 56px);

}

.input-pesquisa {
    font-weight: 500 !important;
    font-size: 17px !important;
    border-radius: 25px !important;
    padding: 0.5rem 0.9rem !important;
    max-width: 50%;
    min-width: 170px;
    float: right;
    transition: 0.5s;
}

.input-pesquisa:focus {
    max-width: 100% !important;
}

.generic-button {
    width: 80px;
    height: 40px;
    border-radius: 20px;
    border: none;
    color: white;
    font-size: 14px;
    font-weight: 700;
    margin: 0px 5px;
    transition: 0.5s;
}

.generic-button:hover {
    opacity: 0.6;
}

.button-back {
    background-color: white;
    border: #3c8dbc solid 2px;
    color: #3c8dbc;
}

.button-save {
    background-color: #3c8dbc;
}

.button-delete {
    background-color: #e74646;
}

.form-control {
    height: 44px;
}

main {
    position: relative;
}

.error {
    display: inline-block;
    color: #ff6060;
    font-size: 14px;
    font-weight: 500;
}

.swal2-confirm .swal2-styled {
    border-radius: 20px !important;
}

#root {
    width: 100vw !important;
}

.swal2-height-auto {
    overflow: visible !important;
}

.row-subcontainer {
    padding-right: 0px;
    padding-left: 0px;
}

.row-container {
    justify-content: center;
    width: 100%;
}

.name-screen {
    position: relative;
    top: -7px;
}

.name-screen-title {
    font-weight: 300;
    position: relative;
    top: 5px;
}

.bottom-edit-menu {
    z-index: 10;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background-color: white;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;

}

.edit-mode {
    padding-bottom: 100px;
}

.button-add {
    background-color: var(--color1Ink);
    height: 60px;
    width: 60px;
    right: 20px;
    bottom: 20px;
    position: fixed;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0rem 3rem rgb(0 0 0 / 75%);
    transition: 0.8s;
}


.button-add:hover {
    box-shadow: 0 0rem 3rem rgb(132 139 200 / 0%);
}

.button-add img {
    width: 30px;
    height: 30px;
    margin: 15px;
}

.button-back-list {
    background-color: white;
    border: 3px solid var(--color1Ink);
    height: 60px;
    width: 60px;
    right: 93px;
    bottom: 20px;
    position: fixed;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0rem 3rem rgb(0 0 0 / 75%);
    transition: 0.8s;
}

.button-back-list:hover {
    box-shadow: 0 0rem 3rem rgb(132 139 200 / 0%);
}

.button-back-list img {
    width: 30px;
    height: 30px;
    margin: 12px;
}

@media (max-width:576px) {
    .bottom-edit-menu {
        border-radius: 30px 30px 0px 0px;
        box-shadow: 0px -10px 69px -9px rgba(0, 0, 0, 0.5);
        -webkit-box-shadow: 0px -10px 69px -9px rgba(0, 0, 0, 0.5);
        -moz-box-shadow: 0px -10px 69px -9px rgba(0, 0, 0, 0.5);
    }

    .edit-mode {
        padding-bottom: 100px;
    }

    #layoutSidenav_content {
        background: #f2f2f2;
    }

    .name-screen img {
        width: 30px !important;
    }

    .row-subcontainer {
        padding: 0px;
        margin-top: 15px;
    }

    .row-container {
        justify-content: center;
        width: auto;
    }

    .screenContainer {
        max-height: calc(100vh - 128px);
        min-height: calc(100vh - 128px);
        padding: 18px 15px 15px 15px !important;
    }

    .name-screen {
        top: 0px;
        padding-right: 0px;
        font-size: 26px;
    }

    .name-screen-professionals {

        font-size: 23px;
    }

    .name-search-2 {
        padding: 0px;
    }

    .name-search {
        padding-left: 0px;
    }

    .name-search input {
        height: 38px;
    }

    .modal-top-table {
        display: none;
    }

    .row-subcontainer-list-payment {
        padding-bottom: 215px !important;
    }
}

@media (min-width: 620px) {
    .row-subcontainer-list-payment {
        padding-bottom: 175px !important;
    }
}

@media (max-width: 992px) {
    #layoutSidenav {
        height: 100vh;
        position: fixed;
        width: 100vw;
    }

    .bottom-edit-menu {
        position: fixed;
    }

    .edit-mode {
        padding-bottom: 130px;
    }
}

.verified-icon {
    position: absolute;
    width: 27px;
    max-width: 30px;
    left: -5px;
    top: -7px;
}

.card-menu {
    transition: opacity 0.2s ease, transform 0.2s ease;
    cursor: pointer;
}

.card-menu:hover {
    opacity: 0.9;
    transform: scale(1.01);
}`, "",{"version":3,"sources":["webpack://./src/index-mod.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,qBAAqB;IACrB,4CAAgD;IAChD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAgD;IAChD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAiD;IACjD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAmD;IACnD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAkD;IAClD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAgD;IAChD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAgD;IAChD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAgD;IAChD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAAiD;IACjD,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,0DAA0D;AAC9D;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,8BAA8B;;AAElC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,8BAA8B;IAC9B,iCAAiC;IACjC,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;;AAEjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,gBAAgB;AACpB;;;AAGA;IACI,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;QACI,gCAAgC;QAChC,kDAAkD;QAClD,0DAA0D;QAC1D,uDAAuD;IAC3D;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,uCAAuC;IAC3C;;IAEA;QACI,QAAQ;QACR,kBAAkB;QAClB,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B","sourcesContent":["/* My css */\n:root {\n    --color1Achemed: #00468B;\n    --color2Achemed: #3C8BBA;\n    --color3Achemed: #F7D5CD;\n    --color4Achemed: #56CAF0;\n    --color5Achemed: #8CE4F9;\n}\n\nhtml,\nbody {\n    height: 100%;\n}\n\n* {\n    font-family: 'Roboto';\n}\n\nhtml {\n    overflow: hidden;\n}\n\n.show {\n    z-index: 10000;\n}\n\n.screenContainer {\n    background: #f2f2f2;\n    padding: 18px 30px;\n    min-height: 100%;\n}\n\n.link-menu {\n    margin-left: 10px;\n}\n\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Thin.ttf');\n    font-weight: 100;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Thin.ttf');\n    font-weight: 200;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Light.ttf');\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Regular.ttf');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Medium.ttf');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Bold.ttf');\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Bold.ttf');\n    font-weight: 700;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Bold.ttf');\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/font/roboto/Roboto-Black.ttf');\n    font-weight: 900;\n    font-style: normal;\n}\n\n.text-align-start {\n    text-align: start;\n}\n\n.img-menu {\n    margin-right: 10px;\n    width: 20px;\n}\n\n.posConsult {\n    color: #f2f2f2;\n    /* ou qualquer outra propriedade que você queira ajustar */\n}\n\n.screenContainer {\n    overflow: auto;\n    max-height: calc(100vh - 56px);\n    min-height: calc(100vh - 56px);\n\n}\n\n.input-pesquisa {\n    font-weight: 500 !important;\n    font-size: 17px !important;\n    border-radius: 25px !important;\n    padding: 0.5rem 0.9rem !important;\n    max-width: 50%;\n    min-width: 170px;\n    float: right;\n    transition: 0.5s;\n}\n\n.input-pesquisa:focus {\n    max-width: 100% !important;\n}\n\n.generic-button {\n    width: 80px;\n    height: 40px;\n    border-radius: 20px;\n    border: none;\n    color: white;\n    font-size: 14px;\n    font-weight: 700;\n    margin: 0px 5px;\n    transition: 0.5s;\n}\n\n.generic-button:hover {\n    opacity: 0.6;\n}\n\n.button-back {\n    background-color: white;\n    border: #3c8dbc solid 2px;\n    color: #3c8dbc;\n}\n\n.button-save {\n    background-color: #3c8dbc;\n}\n\n.button-delete {\n    background-color: #e74646;\n}\n\n.form-control {\n    height: 44px;\n}\n\nmain {\n    position: relative;\n}\n\n.error {\n    display: inline-block;\n    color: #ff6060;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.swal2-confirm .swal2-styled {\n    border-radius: 20px !important;\n}\n\n#root {\n    width: 100vw !important;\n}\n\n.swal2-height-auto {\n    overflow: visible !important;\n}\n\n.row-subcontainer {\n    padding-right: 0px;\n    padding-left: 0px;\n}\n\n.row-container {\n    justify-content: center;\n    width: 100%;\n}\n\n.name-screen {\n    position: relative;\n    top: -7px;\n}\n\n.name-screen-title {\n    font-weight: 300;\n    position: relative;\n    top: 5px;\n}\n\n.bottom-edit-menu {\n    z-index: 10;\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    width: 100%;\n    background-color: white;\n    height: 70px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px;\n\n}\n\n.edit-mode {\n    padding-bottom: 100px;\n}\n\n.button-add {\n    background-color: var(--color1Ink);\n    height: 60px;\n    width: 60px;\n    right: 20px;\n    bottom: 20px;\n    position: fixed;\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 0rem 3rem rgb(0 0 0 / 75%);\n    transition: 0.8s;\n}\n\n\n.button-add:hover {\n    box-shadow: 0 0rem 3rem rgb(132 139 200 / 0%);\n}\n\n.button-add img {\n    width: 30px;\n    height: 30px;\n    margin: 15px;\n}\n\n.button-back-list {\n    background-color: white;\n    border: 3px solid var(--color1Ink);\n    height: 60px;\n    width: 60px;\n    right: 93px;\n    bottom: 20px;\n    position: fixed;\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 0rem 3rem rgb(0 0 0 / 75%);\n    transition: 0.8s;\n}\n\n.button-back-list:hover {\n    box-shadow: 0 0rem 3rem rgb(132 139 200 / 0%);\n}\n\n.button-back-list img {\n    width: 30px;\n    height: 30px;\n    margin: 12px;\n}\n\n@media (max-width:576px) {\n    .bottom-edit-menu {\n        border-radius: 30px 30px 0px 0px;\n        box-shadow: 0px -10px 69px -9px rgba(0, 0, 0, 0.5);\n        -webkit-box-shadow: 0px -10px 69px -9px rgba(0, 0, 0, 0.5);\n        -moz-box-shadow: 0px -10px 69px -9px rgba(0, 0, 0, 0.5);\n    }\n\n    .edit-mode {\n        padding-bottom: 100px;\n    }\n\n    #layoutSidenav_content {\n        background: #f2f2f2;\n    }\n\n    .name-screen img {\n        width: 30px !important;\n    }\n\n    .row-subcontainer {\n        padding: 0px;\n        margin-top: 15px;\n    }\n\n    .row-container {\n        justify-content: center;\n        width: auto;\n    }\n\n    .screenContainer {\n        max-height: calc(100vh - 128px);\n        min-height: calc(100vh - 128px);\n        padding: 18px 15px 15px 15px !important;\n    }\n\n    .name-screen {\n        top: 0px;\n        padding-right: 0px;\n        font-size: 26px;\n    }\n\n    .name-screen-professionals {\n\n        font-size: 23px;\n    }\n\n    .name-search-2 {\n        padding: 0px;\n    }\n\n    .name-search {\n        padding-left: 0px;\n    }\n\n    .name-search input {\n        height: 38px;\n    }\n\n    .modal-top-table {\n        display: none;\n    }\n\n    .row-subcontainer-list-payment {\n        padding-bottom: 215px !important;\n    }\n}\n\n@media (min-width: 620px) {\n    .row-subcontainer-list-payment {\n        padding-bottom: 175px !important;\n    }\n}\n\n@media (max-width: 992px) {\n    #layoutSidenav {\n        height: 100vh;\n        position: fixed;\n        width: 100vw;\n    }\n\n    .bottom-edit-menu {\n        position: fixed;\n    }\n\n    .edit-mode {\n        padding-bottom: 130px;\n    }\n}\n\n.verified-icon {\n    position: absolute;\n    width: 27px;\n    max-width: 30px;\n    left: -5px;\n    top: -7px;\n}\n\n.card-menu {\n    transition: opacity 0.2s ease, transform 0.2s ease;\n    cursor: pointer;\n}\n\n.card-menu:hover {\n    opacity: 0.9;\n    transform: scale(1.01);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
